import zegel from "../../assets/img/zegel.png";

const FooterInterno = () => {
  return (
    <div className="dashboard-footer">
      <div className="footer-content">
        <div style={{ height: 16 }}>
          <p style={{ color: "#fff", fontSize: 12 }}>Con resplado de: </p>
        </div>
        <div className="flex align-items-center gap-4 mt-2">
        
          

          <img
            src={zegel}
            height={40} style={{ height: 40 }}
          ></img> 
          {/* <img
            src="https://zegelvirtual.nyc3.cdn.digitaloceanspaces.com/assets/logosCorreo/zegelIpae.png"
            height={32} style={{ height: 32 }}
          ></img>  */}
          <img
            src="https://zegelvirtual.nyc3.cdn.digitaloceanspaces.com/assets/logosCorreo/logo_intercorp.png"
            height={20} style={{ height: 20 }}
          ></img>
        </div>
      </div>
    </div>
  );
};

export default FooterInterno;
